import { render, staticRenderFns } from "./AppDepartmentAboutBlock.vue?vue&type=template&id=f26252aa"
import script from "./AppDepartmentAboutBlock.vue?vue&type=script&lang=js"
export * from "./AppDepartmentAboutBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports